"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewport = void 0;
exports.getViewport = function (state) { return state.mapsearch.viewport; };
